import react, { useEffect, useState } from 'react';
import { Text, Image, SimpleGrid, Box } from '@chakra-ui/react';

export function RoundX ({JsonX, isConnected}) {

    const [phaseColorWL, setPhaseColorWL] = useState()
    const [phaseColorAL, setPhaseColorAL] = useState()
    const [phaseColorPB, setPhaseColorPB] = useState()

    const totalLeft =  JsonX.collectionSize - JsonX.totalSupply ;
    const whitelistLeft = JsonX.maxWhitelistMinted + JsonX.teamSupply - JsonX.totalSupply ;
    const team1 = JsonX.teamSupply + 1 ;
    const team2 = JsonX.maxWhitelistMinted ;


    useEffect(() => {

        runPhase()

    },[JsonX])

    
    function runPhase() {

        // console.log("RUN PHASE")
        if ( JsonX.mintPhase == 0 ) {
            // 0 = not start yet
            // console.log("0 = not start yet")
            setPhaseColorWL("white")
            setPhaseColorAL("white")
            setPhaseColorPB("white")

        }
        else if ( JsonX.mintPhase == 1 ) {
            // 1 = WL Round
            console.log("1 = WL Round")    
            setPhaseColorWL("#00cccc")
            setPhaseColorAL("white")
            setPhaseColorPB("white")
        }
        else if ( JsonX.mintPhase == 2 ) {
            // 2 = END WL Round
            // console.log("2 = END WL Round")
            setPhaseColorWL("gray")
            setPhaseColorAL("white")
            setPhaseColorPB("white")

        }
        else if (JsonX.mintPhase == 3) {
            // 3 = AL Round
            // console.log("3 = AL Round")
            setPhaseColorWL("gray")
            setPhaseColorAL("#00cccc")
            setPhaseColorPB("white")

        }
        else if (JsonX.mintPhase == 4) {
            // 4 = END AL Round
            // console.log("4 = END AL Round")
            setPhaseColorWL("gray")
            setPhaseColorAL("gray")
            setPhaseColorPB("white")

        }
        else if (JsonX.mintPhase == 5) {
            // 5 = PB Round
            // console.log("5 = PB Round")
            setPhaseColorWL("gray")
            setPhaseColorAL("gray")
            setPhaseColorPB("#00cccc")
        }
        else if (JsonX.mintPhase == 6) {
            // 6 = END PB Round
            // console.log("6 = END PB Round")
            setPhaseColorWL("gray")
            setPhaseColorAL("gray")
            setPhaseColorPB("gray")
        }
        else {
            // Else
            // console.log("Else")
            setPhaseColorWL("white")
            setPhaseColorAL("white")
            setPhaseColorPB("white")

        }
    }


    return(
        <>
            <SimpleGrid
                        columns={[1, null , 1]}
                        paddingLeft="0px"
                        paddingRight="0px"
                        margin="50px 0px"

                    >

                        <Text
                            fontSize='5xl'
                            color="white"
                            fontWeight="800"
                        >Mint Schedule</Text>
                        <Box
                            m="5px"
                            p="10px"
                            borderRadius="20px"
                            backgroundColor={phaseColorWL}
                        >
                            <Text fontSize='2xl' fontWeight="800" >Whitelist Round</Text>
                            <Text fontSize='lg' >Allocation : 5455</Text>
                            <Text fontSize='lg' >Price : FREE</Text>
                            <Text fontSize='xl' fontWeight="600">Nov 18, 13:00 - Nov 19, 13:00 (UTC+7)</Text>
                            <Text fontSize='lg' >(NFT for Whitelist round : #{team1} - #{team2})</Text>
                            <Text fontSize='lg' >(There are {totalLeft} NFT left for Whitelist round.)</Text>
                        </Box>

                        <Box
                            m="5px"
                            p="10px"
                            borderRadius="20px"
                            backgroundColor={phaseColorPB}
                        >
                            <Text fontSize='2xl' fontWeight="800" >Public Round</Text>
                            <Text fontSize='lg'>Allocation : 0</Text>
                            <Text fontSize='lg' >Price : FREE</Text>
                            <Text fontSize='xl'fontWeight="600" >Nov 19, 13:00 ~ (UTC+7)</Text>
                            <Text fontSize='lg' >(There are {totalLeft} NFT left for Public round.)</Text>
                        </Box>

                    </SimpleGrid>
         
      
        </>

    )

}